<!-- ── Main content ────────────────────────────────────────────── -->
<main class="mx-auto max-w-7xl px-4 py-6 sm:px-6 lg:px-8">

  <!-- ── Stats grid ──────────────────────────────────────────── -->
  <dl class="grid grid-cols-2 gap-3 lg:grid-cols-3 mb-5">

    <!-- Visitors -->
    <div class="rounded-lg bg-white p-4 shadow-sm ring-1 ring-gray-900/5">
      <div class="flex items-start justify-between">
        <div class="min-w-0">
          <p class="text-xs font-medium text-gray-500 uppercase tracking-wide">Visitors</p>
          <p class="mt-1 text-2xl font-semibold text-gray-800 tabular-nums">{{ stats?.nbr_visitors ?? '—' }}</p>
        </div>
        <div class="rounded-lg bg-blue-50 p-2 shrink-0 ml-3">
          <svg class="h-5 w-5 text-blue-400" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" d="M15 19.128a9.38 9.38 0 0 0 2.625.372 9.337 9.337 0 0 0 4.121-.952 4.125 4.125 0 0 0-7.533-2.493M15 19.128v-.003c0-1.113-.285-2.16-.786-3.07M15 19.128v.106A12.318 12.318 0 0 1 8.624 21c-2.331 0-4.512-.645-6.374-1.766l-.001-.109a6.375 6.375 0 0 1 11.964-3.07M12 6.375a3.375 3.375 0 1 1-6.75 0 3.375 3.375 0 0 1 6.75 0Zm8.25 2.25a2.625 2.625 0 1 1-5.25 0 2.625 2.625 0 0 1 5.25 0Z" />
          </svg>
        </div>
      </div>
      <button (click)="activeTab = 'visitors'" class="mt-2 text-xs text-blue-500 hover:text-blue-700">View all &rarr;</button>
    </div>

    <!-- Exhibitors -->
    <div class="rounded-lg bg-white p-4 shadow-sm ring-1 ring-gray-900/5">
      <div class="flex items-start justify-between">
        <div class="min-w-0">
          <p class="text-xs font-medium text-gray-500 uppercase tracking-wide">Exhibitors</p>
          <p class="mt-1 text-2xl font-semibold text-gray-800 tabular-nums">{{ stats?.nbr_exhibitors ?? '—' }}</p>
        </div>
        <div class="rounded-lg bg-violet-50 p-2 shrink-0 ml-3">
          <svg class="h-5 w-5 text-violet-400" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" d="M13.5 21v-7.5a.75.75 0 0 1 .75-.75h3a.75.75 0 0 1 .75.75V21m-4.5 0H2.36m11.14 0H18m0 0h3.64m-1.39 0V9.349M3.75 21V9.349m0 0a3.001 3.001 0 0 0 3.75-.615A2.993 2.993 0 0 0 9.75 9.75c.896 0 1.7-.393 2.25-1.016a2.993 2.993 0 0 0 2.25 1.016 2.993 2.993 0 0 0 2.25-1.016 3.001 3.001 0 0 0 3.75.614m-16.5 0a3.004 3.004 0 0 1-.621-4.72l1.189-1.19A1.5 1.5 0 0 1 5.378 3h13.243a1.5 1.5 0 0 1 1.06.44l1.19 1.189a3 3 0 0 1-.621 4.72M6.75 18h3.75a.75.75 0 0 0 .75-.75V13.5a.75.75 0 0 0-.75-.75H6.75a.75.75 0 0 0-.75.75v3.75c0 .414.336.75.75.75Z" />
          </svg>
        </div>
      </div>
      <button (click)="activeTab = 'exhibitors'" class="mt-2 text-xs text-violet-500 hover:text-violet-700">View all &rarr;</button>
    </div>

    <!-- Appointments -->
    <div class="rounded-lg bg-white p-4 shadow-sm ring-1 ring-gray-900/5">
      <div class="flex items-start justify-between">
        <div class="min-w-0">
          <p class="text-xs font-medium text-gray-500 uppercase tracking-wide">Appointments</p>
          <p class="mt-1 text-2xl font-semibold text-gray-800 tabular-nums">{{ stats?.nbr_appointments ?? '—' }}</p>
        </div>
        <div class="rounded-lg bg-orange-50 p-2 shrink-0 ml-3">
          <svg class="h-5 w-5 text-orange-400" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5" />
          </svg>
        </div>
      </div>
      <p class="mt-2 text-xs text-gray-400">Scheduled meetings</p>
    </div>

    <!-- Registered -->
    <div class="rounded-lg bg-white p-4 shadow-sm ring-1 ring-gray-900/5">
      <div class="flex items-start justify-between">
        <div class="min-w-0">
          <p class="text-xs font-medium text-gray-500 uppercase tracking-wide">Registered</p>
          <p class="mt-1 text-2xl font-semibold text-gray-800 tabular-nums">{{ stats?.nbr_registered ?? '—' }}</p>
        </div>
        <div class="rounded-lg bg-sky-50 p-2 shrink-0 ml-3">
          <svg class="h-5 w-5 text-sky-400" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" d="M19 7.5v3m0 0v3m0-3h3m-3 0h-3m-2.25-4.125a3.375 3.375 0 1 1-6.75 0 3.375 3.375 0 0 1 6.75 0ZM4 19.235v-.11a6.375 6.375 0 0 1 12.75 0v.109A12.318 12.318 0 0 1 10.374 21c-2.331 0-4.512-.645-6.374-1.766Z" />
          </svg>
        </div>
      </div>
      <p class="mt-2 text-xs text-gray-400">Awaiting approval</p>
    </div>

    <!-- Approved -->
    <div class="rounded-lg bg-white p-4 shadow-sm ring-1 ring-gray-900/5">
      <div class="flex items-start justify-between">
        <div class="min-w-0">
          <p class="text-xs font-medium text-gray-500 uppercase tracking-wide">Approved</p>
          <p class="mt-1 text-2xl font-semibold text-gray-800 tabular-nums">{{ stats?.nbr_approved ?? '—' }}</p>
        </div>
        <div class="rounded-lg bg-emerald-50 p-2 shrink-0 ml-3">
          <svg class="h-5 w-5 text-emerald-400" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" d="M9 12.75 11.25 15 15 9.75m-3-7.036A11.959 11.959 0 0 1 3.598 6 11.99 11.99 0 0 0 3 9.749c0 5.592 3.824 10.29 9 11.623 5.176-1.332 9-6.03 9-11.622 0-1.31-.21-2.571-.598-3.751h-.152c-3.196 0-6.1-1.248-8.25-3.285Z" />
          </svg>
        </div>
      </div>
      <p class="mt-2 text-xs text-gray-400">Confirmed participants</p>
    </div>

    <!-- Firststart Done -->
    <div class="rounded-lg bg-white p-4 shadow-sm ring-1 ring-gray-900/5">
      <div class="flex items-start justify-between">
        <div class="min-w-0">
          <p class="text-xs font-medium text-gray-500 uppercase tracking-wide">Firststart Done</p>
          <p class="mt-1 text-2xl font-semibold text-gray-800 tabular-nums">{{ stats?.nbr_fs_done ?? '—' }}</p>
        </div>
        <div class="rounded-lg bg-amber-50 p-2 shrink-0 ml-3">
          <svg class="h-5 w-5 text-amber-400" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" d="M11.48 3.499a.562.562 0 0 1 1.04 0l2.125 5.111a.563.563 0 0 0 .475.345l5.518.442c.499.04.701.663.321.988l-4.204 3.602a.563.563 0 0 0-.182.557l1.285 5.385a.562.562 0 0 1-.84.61l-4.725-2.885a.562.562 0 0 0-.586 0L6.982 20.54a.562.562 0 0 1-.84-.61l1.285-5.386a.562.562 0 0 0-.182-.557l-4.204-3.602a.562.562 0 0 1 .321-.988l5.518-.442a.563.563 0 0 0 .475-.345L11.48 3.5Z" />
          </svg>
        </div>
      </div>
      <p class="mt-2 text-xs text-gray-400">Profile setup complete</p>
    </div>

  </dl><!-- /stats grid -->

  <!-- ── Tables card ──────────────────────────────────────────── -->
  <div class="rounded-xl bg-white shadow-sm ring-1 ring-gray-900/5 overflow-hidden">

    <!-- Tab bar -->
    <div class="bg-gray-50 border-b border-gray-200 px-6">
      <nav class="-mb-px flex gap-1">
        <button (click)="activeTab = 'visitors'"
          [class]="activeTab === 'visitors'
            ? 'bg-white border-l border-r border-t border-gray-200 text-blue-900 font-semibold -mb-px'
            : 'text-gray-500 hover:text-gray-800 hover:bg-gray-100'"
          class="whitespace-nowrap px-6 py-3 text-sm rounded-t transition-colors duration-150">
          Visitors
        </button>
        <button (click)="activeTab = 'exhibitors'"
          [class]="activeTab === 'exhibitors'
            ? 'bg-white border-l border-r border-t border-gray-200 text-blue-900 font-semibold -mb-px'
            : 'text-gray-500 hover:text-gray-800 hover:bg-gray-100'"
          class="whitespace-nowrap px-6 py-3 text-sm rounded-t transition-colors duration-150">
          Exhibitors
        </button>
        <button (click)="activeTab = 'videos'"
          [class]="activeTab === 'videos'
            ? 'bg-white border-l border-r border-t border-gray-200 text-blue-900 font-semibold -mb-px'
            : 'text-gray-500 hover:text-gray-800 hover:bg-gray-100'"
          class="whitespace-nowrap px-6 py-3 text-sm rounded-t transition-colors duration-150">
          Videos
        </button>
      </nav>
    </div>

    <!-- Tab panels -->
    <div [hidden]="activeTab !== 'visitors'">
      <app-visitors-view (visitorSelected)="showPageDetailVisitor($event)"></app-visitors-view>
    </div>
    <div [hidden]="activeTab !== 'exhibitors'">
      <app-exhibitors-view (exhibitorSelected)="showPageDetailExhibitor($event)"></app-exhibitors-view>
    </div>
    <div [hidden]="activeTab !== 'videos'">
      <app-videos-view></app-videos-view>
    </div>

  </div><!-- /tables card -->

  <footer class="mt-6 text-center">
    <span class="text-xs text-gray-400">&copy; {{ _eventYear }} {{ _veranstalter }} &mdash; All Rights Reserved.</span>
  </footer>

</main>
